import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

// const AlbumRepository = RepositoryFactory.get('album');
const UserRepository = RepositoryFactory.get('user');

const state = {
  user: {},
  loading: false,
  profileId: ''
}

const actions = {
  async getUserById ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      UserRepository.getUserById(userId).then(response => {
        const user = response.data;
        commit('SET_USER', user);
        resolve(user);
      }).catch((error) => {
        commit('SET_USER', null);
        reject(error);
      });
    });
  }
}

const mutations = {
  SET_LOADING (state, loading) {
    state.loading = loading;
  },
  SET_USER (state, user) {
    state.user = user;
  },
  SET_PROFILE_ID (state, profileId) {
    const slugSplit = profileId.split('-');
    state.profileId = parseInt(slugSplit[0]);
  }
}

const getters = {
  getLoading: state => state.loading,
  getUser: state => state.user,
  getProfileId: state => state.profileId,
  getUserIsOwner (state, getters, rootState, rootGetters) {
    const user = rootGetters['user/user'];
    return user !== null && user.id === getters.getProfileId
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
